import React, { Component } from "react";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import MapForm from "./MapForm";
import withValues from "../hocs/withValues";

class RateCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
      customer: null,
      customerQuery: null,
      origin: null,
      destination: null,
      vehicle: null,
      vehicleQuery: null,
      billType: null,
      supplierCost: null,
      supplierCurrency: null,
      dueDate: null,
    };
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ showContent: true });
    }, 300);
  }

  componentDidUpdate(prevProps) {
    if (this.props.values !== prevProps.values) {
      this.setState({
        customer: getValue(this.props.values, "customer")
      });
    }
  }

  getCustomerFilter() {
    let customerFilter = {
      or: [
        {
          id: this.state.customer
        }
      ]
    };

    if (this.state.customerQuery) {
      customerFilter.or = [
        ...customerFilter.or,
        {
          active: true,
          name: {
            contains: this.state.customerQuery
          }
        }
      ];
    }

    return customerFilter;
  }

  renderMap() {
    if (this.state.origin && this.state.destination) {
      this.setState({ showContent: false }, () => {
        this.setState({ showContent: true });
      });
    }
  }

  render() {
    const customerFilter = this.getCustomerFilter();

    return (
      <div style={{ display: this.state.showContent ? "block" : "hidden" }}>
        <Row gutter={10}>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              model={"rates"}
              attribute={"customer"}
              onSearch={value => {
                this.setState({ customerQuery: value });
              }}
              onChange={value => {
                this.setState({ customer: value });
              }}
              placeholder={"Busca un cliente"}
              filter={customerFilter}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"rates"}
              attribute={"origin"}
              onChange={value => {
                this.setState({ origin: JSON.parse(value) });
                this.renderMap();
              }}
              filter={{ customer: this.state.customer }}
              needFullValue
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              model={"rates"}
              attribute={"destination"}
              onChange={value => {
                this.setState({ destination: JSON.parse(value) });
                this.renderMap();
              }}
              filter={{ customer: this.state.customer }}
              needFullValue
            />
          </Col>
          <Col span={24}>
            <div style={{ height: "400px", padding: "0 25px", marginBottom: 20 }}>
              {this.state.showContent && (
                <MapForm
                  center={{
                    lat: getValue(this.props.values, "lat"),
                    lng: getValue(this.props.values, "lng")
                  }}
                  form={this.props.form}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBzhd2gYGYfl0bdmCeLGrOjtwzcKcfYmF0&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: "100%" }} />}
                  containerElement={
                    <div
                      style={{
                        height: 400,
                        borderRadius: 3,
                        overflow: "hidden"
                      }}
                    />
                  }
                  mapElement={<div style={{ height: "100%" }} />}
                  locate={false}
                  directions={{
                    origin: this.state.origin,
                    destination: this.state.destination
                  }}
                />
              )}
            </div>
          </Col>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              model={"rates"}
              attribute={"dispatchtype"}
              onChange={value => {
                this.setState({ type: value }, () => {
                  this.props.form.setFieldsValue({
                    serviceType: value === 3 ? 4 : undefined
                  });
                });
              }}
            />
          </Col>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              model={"rates"}
              attribute={"vehicletype"}
              placeholder={"Ingresa un número de placas/económico"}
              ajax
              onSearch={value => {
                this.setState({ vehicleQuery: value });
              }}
              onChange={value => {
                this.setState({ vehicle: value });
              }}
              // filter={vehicleFilter}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"amount"}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              type={"model"}
              items={["MXN", "USD"]}
              autoSave
              attribute={"currency"}
              value={this.state.currency}
              onChange={value => {
                this.setState({ currency: value });
              }}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"supplierCost"}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              type={"model"}
              items={["MXN", "USD"]}
              autoSave
              attribute={"supplierCurrency"}
              value={this.state.supplierCurrency}
              onChange={value => {
                this.setState({ supplierCurrency: value });
              }}
            />
          </Col>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"dueDate"}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withValues(RateCreate);



// WEBPACK FOOTER //
// ./src/forms/RateCreate.js